import  AumentoCupoContent  from './AumentoCupo/AumentoCupoContent';

import React from 'react';
import {useJumboApp} from "@jumbo/hooks";
import {LAYOUT_NAMES} from "../../../layouts/layouts";


const AumentoCupoPage = () => {
  const {setActiveLayout} = useJumboApp();

  React.useEffect(() => {
      setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
      <div>
        <h2>Aumento de Monto</h2>
            <AumentoCupoContent/>
      </div>
  );
};

export default AumentoCupoPage;